import React from 'react';
import Title from './title';
import Eyebrow from './eyebrow';
import Label from './label';
import Subheading from './subheading';
import Description from './description';
import { TextComponentProps } from './text-props.type';

export interface TextProps extends TextComponentProps {
  type?: 'label' | 'eyebrow' | 'title' | 'subheading' | 'description';
  htmlFor?: string;
}

const Text = ({
  type,
  role = undefined,
  tag,
  fontSize,
  fontColor,
  className = '',
  stringText,
  richText = [],
  id = undefined,
  margin,
  htmlFor,
}: TextProps): JSX.Element | null => {
  switch (type) {
    case 'label':
      return (
        <Label
          fontSize={fontSize}
          fontColor={fontColor}
          stringText={stringText}
          className={className}
          margin={margin}
          htmlFor={htmlFor}
        />
      );

    case 'eyebrow':
      return (
        <Eyebrow
          fontSize={fontSize}
          fontColor={fontColor}
          stringText={stringText}
          className={className}
          margin={margin}
        />
      );

    case 'title':
      return (
        <Title
          tag={tag}
          fontSize={fontSize}
          fontColor={fontColor}
          stringText={stringText}
          className={className}
          id={id}
          role={role}
          margin={margin}
        />
      );

    case 'subheading':
      return (
        <Subheading
          fontColor={fontColor}
          fontSize={fontSize}
          richText={richText}
          className={className}
          margin={margin}
        />
      );

    default:
      return (
        <Description
          fontSize={fontSize}
          fontColor={fontColor}
          richText={richText}
          className={className}
          margin={margin}
        />
      );
  }
};

export default Text;
